// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1TvWE","red_plain":"Button_red_plain__14QZ_","green":"Button_green__25Qhm","red":"Button_red__2EWNf","yellow":"Button_yellow__2_8Xt"};